var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlurLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_55_2298)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 24,
    fill: "#FFC7E1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 20,
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 22.5C19.5015 29.5272 26.9099 33.3518 34.8148 36.4053C37.4763 37.4339 40.2124 38.2698 42.9064 39.2158C47.0707 40.6802 50.0697 43.4244 51.9003 47.4434C52.3352 48.3991 52.7701 49.3629 53.2976 50.2685C54.69 52.6611 56.6066 54.4187 59.4726 54.7556C63.1029 55.1817 65.7092 53.531 67.5641 50.5196C67.9455 49.9008 68.2506 49.2317 68.6628 48.6356C71.4834 44.5729 76.9654 44.0334 80.5016 47.4547C80.56 47.5114 80.6395 47.5568 80.6736 47.6248C81.5386 49.3565 83.2101 49.9105 84.8638 50.4936C85.0391 50.5552 85.203 50.6459 85.5 50.782C85.005 50.8954 84.635 50.9829 84.2634 51.0671C81.3 51.7377 79.4873 53.6719 78.4827 56.4241C77.7736 58.3696 77.2169 60.3719 76.4915 62.3125C74.7713 66.9195 72.264 71.0406 68.2263 73.9645C61.5953 78.7659 54.4969 79.179 47.121 75.7561C46.0466 75.2572 44.9983 74.7048 43.9353 74.1848C41.7785 73.127 39.5893 72.1583 37.142 71.8473C41.3355 70.6842 45.1833 68.925 48.3917 65.8196C47.009 65.6949 45.701 65.6155 44.4043 65.4535C39.6964 64.8671 35.683 62.7515 32.1241 59.7239C26.7054 55.1169 22.9874 49.2755 20.0776 42.8785C17.2928 36.7439 15.4849 30.2999 14.2223 23.6939C14.1574 23.3537 14.0957 23.0135 14 22.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_55_2298"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlurLogoIcon);
export default __webpack_public_path__ + "static/media/plur-logo-icon.2efef7cee93121272847b2e2a56c001f.svg";
export { ForwardRef as ReactComponent };